document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('.js-projects-toggle');
    const projectsOngoing = document.querySelector('.js-projects-ongoing');
    const projectsArchived = document.querySelector('.js-projects-archived');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const target = this.getAttribute('data-target');
            
            toggleButtons.forEach(btn => {
                btn.classList.remove('active');
                btn.classList.remove('btn--yellow');
                btn.classList.add('btn--grey');
            });

            this.classList.add('active');
            this.classList.remove('btn--grey');
            this.classList.add('btn--yellow');

            projectsOngoing.classList.remove('active');
            projectsArchived.classList.remove('active');

            if (target === 'ongoing') {
                projectsOngoing.classList.add('active');
            } else if (target === 'archived') {
                projectsArchived.classList.add('active');
            }

            history.pushState(null, null, this.getAttribute('href'));
        });
    });

    const hash = window.location.hash;
    if (hash === '#archived') {
        const archivedButton = document.querySelector('[data-target="archived"]');
        if (archivedButton) archivedButton.click();
    }
});